import React from 'react';
import { useSelector } from 'react-redux';

import { WAITLIST_PREFERENCE_TYPES } from 'dpl/shared/constants/breeder_app';
import { RESULTS_TYPE } from 'dpl/constants/query_params';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import TransportationFilter from './TransportationFilter';
import GenderFilter from './GenderFilter';
import PriceFilter from './PriceFilter';
import LocationFilter from './LocationFilter';
import SizeFilter from './SizeFilter';
import ColorFilter from './ColorFilter';
import AttributesFilter from './AttributesFilter';
import BreederBreedHealthFilter from './BreederBreedHealthFilter';

const { SIZE } = WAITLIST_PREFERENCE_TYPES;

export default function SearchFilters() {
  const { server, queryParams } = useSelector(state => state);
  const resultsType = queryParams[RESULTS_TYPE] || RESULTS_TYPES.PUPPIES;

  const hasSizePreapplied = Boolean(server.preappliedFilters?.[SIZE]);
  const isPuppiesTabActive = resultsType === RESULTS_TYPES.PUPPIES;
  const shouldShowPuppyFilters = isPuppiesTabActive;
  const shouldShowBreederFilters = !isPuppiesTabActive;

  return (
    <>
      <TransportationFilter />
      <LocationFilter resultsType={resultsType} />
      {!hasSizePreapplied && <SizeFilter />}
      {shouldShowPuppyFilters && (
        <>
          <PriceFilter />
          <GenderFilter />
        </>
      )}
      <ColorFilter />
      {shouldShowBreederFilters && <BreederBreedHealthFilter />}
      <AttributesFilter />
    </>
  );
}
